<template>
    <div>
       <HeaderTeam header="รายงานและการสรุปยอด" :img_header="header_image" link_back="summary"/>
       <MenuTeamReportAndSummaryList/>
       <EditPartTimeSummaryList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/dashboard.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamReportAndSummaryList from '@/components/menuadmin/team/teamreportandsummary/MenuTeamReportAndSummaryList.vue'
import EditPartTimeSummaryList from '@/components/menuadmin/team/teamreportandsummary/EditPartTimeSummaryList.vue'
export default {
    name:'editPartTimeSummary',
    components:{
        HeaderTeam,
        MenuTeamReportAndSummaryList,
        EditPartTimeSummaryList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>